import { render, staticRenderFns } from "./SurveyPreview.vue?vue&type=template&id=173bb20e&scoped=true&"
import script from "./SurveyPreview.vue?vue&type=script&lang=js&"
export * from "./SurveyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173bb20e",
  null
  
)

export default component.exports